import { ClassAttributes, ButtonHTMLAttributes, type MouseEvent } from 'react';
import AppleSignin from 'react-apple-signin-auth';
import { JSX } from 'react/jsx-runtime';
import { AppleLogin } from '../../assets';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { SocialLoginButtonsProps, SocialLoginPlatformEnum } from './type';
import { t } from 'i18next';
import SocialLoginBtn from './SocialLoginBtn';

export default function AppleLoginBtn({
  afterSocialLoginSuccess,
  dataSocial,
  variant = 'legacy',
  recentLogin,
}: SocialLoginButtonsProps) {
  const navigate = useNavigate();
  const isRecent = variant === 'draft' && recentLogin === dataSocial;

  return (
    <div
      data-social={dataSocial}
      className={isRecent ? 'login-social-wrap--recent' : undefined}
    >
      <AppleSignin
        authOptions={{
          clientId: `${process.env.REACT_APP_APPLE_CLIENT_ID}`,
          scope: 'email name',
          redirectURI: `${process.env.REACT_APP_APPLE_REDIRECT_URL}`,
          state: 'state',
          nonce: 'nonce',
          usePopup: true,
        }}
        uiType="dark"
        className="apple-auth-btn"
        noDefaultStyle={false}
        buttonExtraChildren="Continue with Apple"
        onSuccess={(response: any) => {
          const { authorization } = response;
          const { id_token } = authorization;
          const decodedToken = jwtDecode<any>(id_token);
          const { sub, email } = decodedToken;
          afterSocialLoginSuccess({
            type: SocialLoginPlatformEnum.APPLE,
            socialId: sub,
            email: email,
          });
        }}
        onError={(error: any) => {
          console.error('애플 로그인 실패', error);
          navigate('/auth', { replace: true });
        }}
        skipScript={false}
        render={(
          props: JSX.IntrinsicAttributes &
            ClassAttributes<HTMLButtonElement> &
            ButtonHTMLAttributes<HTMLButtonElement>
        ) => {
          if (variant === 'draft') {
            return (
              <SocialLoginBtn
                onClick={() => props.onClick?.({} as MouseEvent<HTMLButtonElement>)}
                backgroundColor="bg-black"
                fontColor="text-white"
                additionalStyle="login-social-btn--apple"
                icon={<AppleLogin width={24} height={24} />}
                text="apple"
                variant="draft"
              />
            );
          }

          return (
            <button
              {...props}
              type="button"
              className="flex h-[48px] w-[48px] items-center justify-center rounded-[8px] bg-black pb-[2px] md:h-[54px] md:w-[357px] md:rounded-full md:px-7 md:pb-0"
            >
              <AppleLogin className="hidden md:block" width={24} height={24} />
              <AppleLogin className="block md:hidden" />
              <span className="hidden px-5 text-[16px] font-medium font-weight-600 leading-[150%] text-white md:block">
                {t('login.apple')}
              </span>
            </button>
          );
        }}
      />
    </div>
  );
}
